import styled from 'styled-components';
import { Flex } from 'UI';

export const BamCodeContainer = styled(Flex)`
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.color.grey70};
`;
